import {
  Avatar,
  Badge,
  Button,
  Flex,
  Td,
  Text,
  Tr,
  Icon,
  Link,
  useColorModeValue,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  useColorMode,
  ModalCloseButton,
  ModalFooter,
  Grid,
  useDisclosure
} from "@chakra-ui/react";
import NiceButton from "components/NiceButton/NiceButton.js";
import React, { useState } from "react";
import config from "config/index";
import { ToastContainer, toast } from 'react-toastify';
import removeChatRoom from "api/chatroom/remove-chatroom";
import { RiChatSmile3Fill } from "react-icons/ri";
import IconBox from "components/Icons/IconBox";



function TablesTableRow(props) {
  const { id, title, status, date, isLast, address,reload,setReload } = props;
  const textColor = useColorModeValue("gray.500", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const iconBlue = useColorModeValue("gray.100", "navy.700");
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { colorMode } = useColorMode();
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  function Delete() {
    setIsDeleteLoading(true)
    removeChatRoom(address,id).then((result) => {
      setReload(!reload)
      onClose()
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsDeleteLoading(false)
    })
  }

  return (
    <>
      <Tr>
        <Td
          minWidth={{ sm: "250px" }}
          pl="0px"
          borderColor={borderColor}
          borderBottom={isLast ? "none" : null}
        >
          <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
            <IconBox ml={"20px"} as='box' >
                            <Icon h={"25px"} w={"25px"} color={titleColor} as={RiChatSmile3Fill} />
                          </IconBox>
            <Flex direction="column">
              <Text
                fontSize="sm"
                color={titleColor}
                fontWeight="bold"
                minWidth="100%"
              >
                {title}
              </Text>
            </Flex>
          </Flex>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Badge
            bg="blue.400"
            color="white"
            fontSize="xs"
            p="3px 10px"
            borderRadius="8px">
            <Link fontSize="xs"
              color='white'
              target="_blank"
              href={config.chathost + "/?roomId=" + id}>
              مشاهده
            </Link>
          </Badge>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Badge
            bg={status === true ? "green.400" : bgStatus}
            color={status === true ? "white" : "white"}
            fontSize="xs"
            p="3px 10px"
            borderRadius="8px"
          >
            {status == true ? "فعال" : "غیرفعال"}
          </Badge>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="xs" color={textColor}  dir="ltr" textAlign="right" pb=".5rem">
            {date}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Button
              onClick={onOpen}
              color="red.400"
              fontSize="xs"
              minW='110px'
              maxH='35px'>
              حذف
            </Button>
        </Td>
      </Tr>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">حذف چت روم</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            چت روم به صورت بی بازگشت حذف خواهد شد، آیا مایل به حذف هستید؟
          </ModalBody>
          <ModalFooter>
            <Button fontSize='xs' onClick={onClose}>خیر</Button>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isDeleteLoading}
              onClick={Delete}
              fontSize='xs'
              w="100px"
            >
              بله
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default TablesTableRow;
